/* eslint-disable no-undef */
import React from 'react';
import Row from 'react-bootstrap/Row';
import Button from '../../components/button/button';
// eslint-disable-next-line no-unused-vars
import questionscss from './questions.css';

const Question0 = props => {
  const { onFinish, content } = { ...props };

  return (
    <>
      {content}
      <Row className="button-wrapper">
        <div>
          <Button
            title="Get started"
            onClick={onFinish}
            variant="primary"
            className="large"
          />
        </div>
      </Row>
    </>
  );
};

export default Question0;
